import React, { FunctionComponent } from 'react';
import { RawIntlProvider } from 'react-intl-next';
import { intlCache } from './intlCache';

export const TrelloIntlProvider: FunctionComponent = ({ children }) => {
  return <RawIntlProvider value={intlCache}>{children}</RawIntlProvider>;
};
